export default "__VITE_ASSET__oYM6Rh$B__"